import { createSlice } from '@reduxjs/toolkit';
import { GetEncryptionKey, GetKeyStoreResources } from '../../api/themesCalls';

export const keySlice = createSlice({
  name: 'key',
  initialState: {
    isEncryptionSet: false,
    encryptionValue: {},
    isStoreKeySet: false,
    storeKeyValue: {},
    isEncryptionKeyFailed: false,
  },
  reducers: {
    setKey: (state) => {
      state.isEncryptionSet = true;
    },
    unSetKeys: (state) => {
      state.isEncryptionSet = false;
      state.isStoreKeySet = false;
      state.encryptionValue = {};
      state.storeKeyValue = {};
      state.isEncryptionKeyFailed = false;
    },
  },
  extraReducers: {
    [GetEncryptionKey.fulfilled]: (state, action) => {
      state.isEncryptionSet = true;
      state.isEncryptionKeyFailed = false;
      state.encryptionValue = action.payload.data.Response || '';
    },
    [GetEncryptionKey.rejected]: (state, action) => {
      state.isEncryptionSet = false;
      state.isEncryptionKeyFailed = true;
      state.encryptionValue = null;
    },
    [GetKeyStoreResources.pending]: (state, action) => {
      state.isStoreKeySet = false;
    },
    [GetKeyStoreResources.fulfilled]: (state, action) => {
      state.isStoreKeySet = true;
      state.storeKeyValue = action.payload.Response || '';
    },
    [GetKeyStoreResources.rejected]: (state, action) => {
      state.isStoreKeySet = false;
      state.storeKeyValue = null;
    },
  },
});

//Action creators are generated for each case reducer function
export const { setKey, unSetKeys } = keySlice.actions;

export default keySlice.reducer;
